import createGetFormMeta from './selectors/getFormMeta';
import plain from './structure/plain';
export default createGetFormMeta(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormMeta.js
// module id = XHhv
// module chunks = 1